import * as THREE from 'three';
import { FileLoader } from 'three';

// Loads *.scene.json

export class PropsLoader<Props> extends THREE.Loader {
  load(
    url: string,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    onLoad: (argument0: any) => void,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    onProgress: any,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    onError: (argument0: any) => void
  ) {
    // THREE.Cache.enabled = true;

    const loader = new FileLoader(this.manager);

    loader.setResponseType('text');

    loader.setRequestHeader(this.requestHeader);
    loader.setWithCredentials(this.withCredentials);
    loader.load(
      url,
      (dataTxt) => {
        try {
          onLoad(this.parse(dataTxt as string));
        } catch (error) {
          if (onError) {
            onError(error);
          } else {
            console.error(error);
          }

          this.manager.itemError(url);
        }
      },
      onProgress,
      onError
    );
  }

  parse(dataTxt: string): Props {
    return JSON.parse(dataTxt as string) as Props;
  }
}

export default PropsLoader;
